/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NSABaseServer } from "namirasoft-account";
import { NamirasoftPaymentServerHealthz } from "./NamirasoftPaymentServerHealthz";
import { NamirasoftPaymentServerInvoice } from "./NamirasoftPaymentServerInvoice";
import { NamirasoftPaymentServerMeter } from "./NamirasoftPaymentServerMeter";
import { NamirasoftPaymentServerOffer } from "./NamirasoftPaymentServerOffer";
import { NamirasoftPaymentServerOneTime } from "./NamirasoftPaymentServerOneTime";
import { NamirasoftPaymentServerPayment } from "./NamirasoftPaymentServerPayment";
import { NamirasoftPaymentServerProduct } from "./NamirasoftPaymentServerProduct";
import { NamirasoftPaymentServerSalesItem } from "./NamirasoftPaymentServerSalesItem";
import { NamirasoftPaymentServerSubscription } from "./NamirasoftPaymentServerSubscription";
import { NamirasoftPaymentServerSubscriptionCancellationReason } from "./NamirasoftPaymentServerSubscriptionCancellationReason";
import { NamirasoftPaymentServerSubscriptionItem } from "./NamirasoftPaymentServerSubscriptionItem";
import { NamirasoftPaymentServerSubscriptionPaid } from "./NamirasoftPaymentServerSubscriptionPaid";
import { NamirasoftPaymentServerValue } from "./NamirasoftPaymentServerValue";
import { TokenManager } from "namirasoft-account";

export class NamirasoftPaymentServer extends NSABaseServer
{
    healthz: NamirasoftPaymentServerHealthz;
    value: NamirasoftPaymentServerValue;
    invoice: NamirasoftPaymentServerInvoice;
    meter: NamirasoftPaymentServerMeter;
    offer: NamirasoftPaymentServerOffer;
    one_time: NamirasoftPaymentServerOneTime;
    payment: NamirasoftPaymentServerPayment;
    sales_item: NamirasoftPaymentServerSalesItem;
    subscription_cancellation_reason: NamirasoftPaymentServerSubscriptionCancellationReason;
    subscription_item: NamirasoftPaymentServerSubscriptionItem;
    subscription_paid: NamirasoftPaymentServerSubscriptionPaid;
    subscription: NamirasoftPaymentServerSubscription;
    product: NamirasoftPaymentServerProduct;
    constructor(base_url: string, manager: TokenManager, onError: (error: Error) => void)
    {
        super(base_url, `1.4.88`, manager, onError);
        this.healthz = new NamirasoftPaymentServerHealthz(this);
        this.value = new NamirasoftPaymentServerValue(this);
        this.invoice = new NamirasoftPaymentServerInvoice(this);
        this.meter = new NamirasoftPaymentServerMeter(this);
        this.offer = new NamirasoftPaymentServerOffer(this);
        this.one_time = new NamirasoftPaymentServerOneTime(this);
        this.payment = new NamirasoftPaymentServerPayment(this);
        this.sales_item = new NamirasoftPaymentServerSalesItem(this);
        this.subscription_cancellation_reason = new NamirasoftPaymentServerSubscriptionCancellationReason(this);
        this.subscription_item = new NamirasoftPaymentServerSubscriptionItem(this);
        this.subscription_paid = new NamirasoftPaymentServerSubscriptionPaid(this);
        this.subscription = new NamirasoftPaymentServerSubscription(this);
        this.product = new NamirasoftPaymentServerProduct(this);
    }
};